import {
  FaTachometerAlt,
  FaUsers,
  FaTasks,
  FaChartBar,
  FaBox,
  FaExchangeAlt,
  FaIndustry,
  FaShoppingCart,
  FaMoneyBillWave,
  FaCalendarCheck,
  FaMapMarkerAlt,
  FaBalanceScale,
  FaCashRegister,
  FaUndo,
  FaTruck,
  FaHistory,
  FaWarehouse,
  FaBarcode,
  FaTruckLoading,
  FaClipboardList,
  FaUserCog,
  FaUserClock,
  FaBoxOpen,
  FaCalculator,
  FaLock,
  FaAward,
  FaReceipt,
  FaHeadset,
  FaBell,
  FaCommentDots,
} from "react-icons/fa";

export const PERMISSION_PAGES = [
  { id: "dashboard", label: "Dashboard", path: "/dashboard" },
  { id: "inventory", label: "Inventory", path: "/inventory" },
  { id: "inventory-history", label: "Inventory History", path: "/inventory/history" },
  { id: "item-history", label: "Item History", path: "/inventory/history/:id" },
  { id: "rooms", label: "Rooms", path: "/inventory?tab=rooms" },
  { id: "barcode", label: "Barcode", path: "/inventory/barcode" },
  { id: "packaging", label: "Packaging", path: "/packaging" },
  { id: "packaging-history", label: "Packaging History", path: "/packaging/history" },
  { id: "movement", label: "Movement", path: "/movement" },
  { id: "manufacture", label: "Manufacture", path: "/manufacture" },
  { id: "purchases", label: "Purchases", path: "/purchases" },
  { id: "purchase-order", label: "Purchase Order", path: "/purchases/order" },
  { id: "supplier-payment", label: "Supplier Payment", path: "/purchases/supplier-payment" },
  { id: "suppliers", label: "Suppliers", path: "/suppliers" },
  { id: "purchase-history", label: "Purchase History", path: "/purchases/history" },
  { id: "supplier-ledger", label: "Supplier Ledger", path: "/supplier-ledger/:supplierId" },
  { id: "supplier-purchase-history", label: "Supplier Purchase History", path: "/purchase/history/:supplierId" },
  { id: "sales", label: "Sales", path: "/sales" },
  { id: "sales-history", label: "Sales History", path: "/sales/history" },
  { id: "tasks", label: "Tasks", path: "/tasks" },
  { id: "task-history", label: "Task History", path: "/task-history/:taskId" },
  { id: "orders", label: "Orders", path: "/orders" },
  { id: "rto", label: "RTO", path: "/rto" },
  { id: "return-in-transit", label: "Return in Transit", path: "/return-in-transit" },
  { id: "tracking", label: "Tracking", path: "/tracking" },
  { id: "customer-returns", label: "Customer Returns", path: "/customer-returns" },
  { id: "reports", label: "Reports", path: "/reports" },
  { id: "master-report", label: "Master Report", path: "/reports/master" },
  { id: "compare", label: "Compare", path: "/compare" },
  { id: "salary", label: "Salary", path: "/salary" },
  { id: "salary-history", label: "Salary History", path: "/salary-history" },
  { id: "attendance", label: "Attendance", path: "/attendance" },
  { id: "attendance-history", label: "Attendance History", path: "/attendance-history" },
  { id: "location-setting", label: "Location Setting", path: "/location-setting" },
  { id: "login-activity", label: "Login Activity", path: "/login-activity" },
  { id: "employees", label: "Employees", path: "/employees" },
  { id: "employee-performance", label: "Employee Performance", path: "/employee-performance" },
  { id: "team-feedback", label: "Team Feedback", path: "/team-feedback", adminOnly: true },
  { id: "employee_activity", label: "Employee Activity", path: "/employee-activity" },
  { id: "roles", label: "Role Management", path: "/roles" },
  { id: "master-pin", label: "Master PIN", path: "/master-pin", adminOnly: true },
  { id: "networth", label: "Net Worth", path: "/networth" },
  { id: "networth-balance-history", label: "Net Worth Balance History", path: "/networth/balance-history" },
  { id: "expense-management", label: "Expense Management", path: "/expense-management" },
  { id: "help-desk", label: "Help Desk", path: "/help-desk", adminOnly: true },
  { id: "notifications", label: "Notifications", path: "/notifications", adminOnly: true },
];

export const APP_PERMISSION_PAGES = [
  { id: "sales", label: "Sales" },
  { id: "manufacture", label: "Manufacture" },
  { id: "rto", label: "RTO" },
];

export const SIDEBAR_PAGES = [
  {
    id: "dashboard",
    permissionId: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    icon: FaTachometerAlt,
  },
  {
    id: "inventory",
    permissionId: "inventory",
    label: "Inventory",
    icon: FaBox,
    children: [
      { permissionId: "inventory", label: "Inventory", path: "/inventory", icon: FaBox },
      { permissionId: "inventory-history", label: "Inventory History", path: "/inventory/history", icon: FaHistory },
      { permissionId: "rooms", label: "Rooms", path: "/inventory?tab=rooms", icon: FaWarehouse },
      { permissionId: "barcode", label: "Barcode", path: "/inventory/barcode", icon: FaBarcode },
    ],
  },
  {
    id: "packaging",
    permissionId: "packaging",
    label: "Packaging",
    path: "/packaging",
    icon: FaBoxOpen,
  },
  {
    id: "movement",
    permissionId: "movement",
    label: "Movement",
    path: "/movement",
    icon: FaExchangeAlt,
  },
  {
    id: "manufacture",
    permissionId: "manufacture",
    label: "Manufacture",
    path: "/manufacture",
    icon: FaIndustry,
  },
  {
    id: "purchases",
    permissionId: "purchases",
    label: "Purchases",
    icon: FaShoppingCart,
    children: [
      { permissionId: "purchases", label: "Purchases", path: "/purchases", icon: FaShoppingCart },
      { permissionId: "purchase-order", label: "Purchase Order", path: "/purchases/order", icon: FaClipboardList },
      { permissionId: "supplier-payment", label: "Supplier Payment", path: "/purchases/supplier-payment", icon: FaMoneyBillWave },
      { permissionId: "suppliers", label: "Suppliers", path: "/suppliers", icon: FaTruckLoading },
      { permissionId: "purchase-history", label: "Purchase History", path: "/purchases/history", icon: FaHistory },
    ],
  },
  {
    id: "sales",
    permissionId: "sales",
    label: "Sales",
    path: "/sales",
    icon: FaCashRegister,
  },
  {
    id: "tasks",
    permissionId: "tasks",
    label: "Tasks",
    path: "/tasks",
    icon: FaTasks,
  },
  {
    id: "orders",
    permissionId: "orders",
    label: "Orders",
    icon: FaShoppingCart,
    children: [
      { permissionId: "orders", label: "Orders", path: "/orders", icon: FaShoppingCart },
      { permissionId: "tracking", label: "Tracking", path: "/tracking", icon: FaTruck },
      { permissionId: "customer-returns", label: "Customer Returns", path: "/customer-returns", icon: FaExchangeAlt },
    ],
  },
  {
    id: "returns",
    permissionId: "rto",
    label: "Return",
    icon: FaUndo,
    children: [
      { permissionId: "rto", label: "RTO", path: "/rto", icon: FaUndo },
      { permissionId: "rto", label: "Return in Transit", path: "/return-in-transit", icon: FaTruck },
    ],
  },
  {
    id: "reports",
    permissionId: "reports",
    label: "Reports",
    icon: FaChartBar,
    children: [
      { permissionId: "reports", label: "Reports", path: "/reports", icon: FaChartBar },
      { permissionId: "reports", label: "Master Report", path: "/reports/master", icon: FaClipboardList },
      { permissionId: "compare", label: "Compare", path: "/compare", icon: FaBalanceScale },
    ],
  },
  {
    id: "salary",
    permissionId: "salary",
    label: "Salary",
    path: "/salary",
    icon: FaMoneyBillWave,
  },
  {
    id: "attendance",
    permissionId: "attendance",
    label: "Attendance",
    icon: FaCalendarCheck,
    children: [
      { permissionId: "attendance", label: "Attendance", path: "/attendance", icon: FaCalendarCheck },
      { permissionId: "attendance-history", label: "Attendance History", path: "/attendance-history", icon: FaHistory },
      { permissionId: "location-setting", label: "Location Setting", path: "/location-setting", icon: FaMapMarkerAlt },
    ],
  },
  {
    id: "employees",
    permissionId: "employees",
    label: "Employees",
    icon: FaUsers,
    children: [
      { permissionId: "employees", label: "Employee List", path: "/employees", icon: FaUsers },
      { permissionId: "employee_activity", label: "Employee Activity", path: "/employee-activity", icon: FaUserClock },
      { permissionId: "employee-performance", label: "Employee Performance", path: "/employee-performance", icon: FaAward },
      { permissionId: "team-feedback", label: "Team Feedback", path: "/team-feedback", icon: FaCommentDots, adminOnly: true },
    ],
  },
  {
    id: "master-pin",
    permissionId: "master-pin",
    label: "Master PIN",
    path: "/master-pin",
    icon: FaLock,
    adminOnly: true,
  },
  {
    id: "roles",
    permissionId: "roles",
    label: "Role Management",
    path: "/roles",
    icon: FaUserCog,
  },
  {
    id: "networth",
    permissionId: "networth",
    label: "Net Worth",
    path: "/networth",
    icon: FaCalculator,
  },
  {
    id: "expense-management",
    permissionId: "expense-management",
    label: "Expense Management",
    path: "/expense-management",
    icon: FaReceipt,
  },
  {
    id: "help-desk",
    permissionId: "help-desk",
    label: "Help Desk",
    path: "/help-desk",
    icon: FaHeadset,
    adminOnly: true,
  },
  {
    id: "notifications",
    permissionId: "notifications",
    label: "Notifications",
    path: "/notifications",
    icon: FaBell,
    adminOnly: true,
  },
];

const permissionLabelMap = new Map(
  PERMISSION_PAGES.map((page) => [page.id, page.label])
);

export const getPermissionLabel = (permissionId) =>
  permissionLabelMap.get(permissionId) || permissionId;
